import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { FeedbackServiceInterface } from './feedback.interface';
import { FeedbackModel } from '../../models/feedback.model';
import { FeedbackTypeModel } from '../../models/feedback-type.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService implements FeedbackServiceInterface {

  constructor(private httpClient: HttpClient) {
  }

  SaveFeedback(model: FeedbackModel): Observable<FeedbackModel[]> {
    //return this.httpClient.post<FeedbackModel[]>(environment.apiBaseUrl + `Feedback/SaveFeedback`, model);
    return of([]);
  }

  GetFeedbackTypes(): Observable<FeedbackTypeModel[]> {
    //return this.httpClient.get<FeedbackTypeModel[]>(environment.apiBaseUrl + `Feedback/GetFeedbackTypes`);
    return of([]);
  }
}
